import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import {
  Card,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  DialogTitle,
  DialogContent,
  IconButton,
  Switch,
  FormControlLabel,
  Link,
} from "@mui/material";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";

import { getHubspotContactEmails } from "./utils";

import { Root, classes, StyledDialog, dialogClasses } from "./styles";

import MSPBillingContactsDialog from "views/Components/MSP/MSPBillingContactsDialog";
import MSPUsageReportsDialog from "views/Components/MSP/MSPUsageReportsDialog";

const tiers = [
  {
    name: "Pay as you go",
    commitment: "No commitment",
    prices: ["$12", "$10.50", "$7", "$1.50", "Free"],
  },
  {
    name: "Tier 1",
    commitment: "$425 per month\n1 year contract term",
    prices: ["$3.5", "$3.5", "$5", "$1.50", "Free"],
  },
  {
    name: "Tier 2",
    commitment: "$1,875 per month\n1 year contract term",
    prices: ["$3", "$3", "$4.50", "$1.50", "Free"],
  },
  {
    name: "Tier 3",
    commitment: "$3250 per month\n1 year contract term",
    prices: ["$2", "$2", "$3", "$1.50", "Free"],
  },
  {
    name: "Tier 4",
    commitment: "$6000 per month\n1 year contract term",
    prices: ["$1.70", "$1.70", "$2.20", "$1.50", "Free"],
  },
  {
    name: "Tier 5",
    commitment: "$11,000 per month\n1 year contract term",
    prices: ["$1.20", "$1.20", "$2", "$1.20", "Free"],
  },
];

const createEmailArray = (emailString) => {
  if (!emailString) {
    return [];
  }

  const emails = emailString.split(",").map((email) => email.trim());
  const emailArray = emails.map((email, index) => ({
    id: index + 1,
    email: email,
  }));

  return emailArray;
};

const MSPBillingPageView = (props) => {
  const [emailArray, setEmailArray] = useState([]);
  const [emailString, setEmailString] = useState("");
  const [selectedTier, setSelectedTier] = useState("");
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const [isBillingContactsDialogOpen, setIsBillingContactsDialogOpen] =
    useState(false);
  const [isUsageReportsDialogOpen, setIsUsageReportsDialogOpen] =
    useState(false);
  const [openAgreementModal, setOpenAgreementModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [currentAgreement, setCurrentAgreement] = useState(true);
  const [mspBillingPlan, setMSPBillingPlan] = useState([]);

  const fetchAndConfigureBillingContacts = async () => {
    // get existing contant email string here
    // and set it to state var for displaying
    const existingString = await getHubspotContactEmails();
    const newEmailArray = createEmailArray(existingString);

    setEmailString(existingString);
    setEmailArray(newEmailArray);
  };

  useEffect(() => {
    fetchAndConfigureBillingContacts();
  }, []);

  useEffect(() => {
    if (props.ready && props.mspBillingPlan[0]) {
      setMSPBillingPlan(props.mspBillingPlan[0]);
    }
  }, [props.ready, props.mspBillingPlan]);

  const handleTierChange = (event) => {
    setSelectedTier(event.target.value);
  };

  const handleExpandAccordion = () => {
    setIsAccordionExpanded(!isAccordionExpanded);
  };

  const handleCreateNewAgreement = () => {
    if (currentAgreement) {
      setOpenAgreementModal(true);
    } else {
      handleExpandAccordion();
    }
  };

  const handleViewInvoices = () => {
    alert("handle viewing invoices, my guy");
  };

  const handleViewUsageReports = () => {
    handleToggleUsageReportsDialog();
  };

  const handleEditPaymentMethod = () => {
    alert("handle edit payment method, plz");
  };

  const handleToggleBillingContactsDialog = () => {
    setIsBillingContactsDialogOpen(!isBillingContactsDialogOpen);
  };

  const handleEditRecipients = () => {
    handleToggleBillingContactsDialog();
  };

  const handleReloadBillingContacts = () => {
    // refresh billing contacts
    fetchAndConfigureBillingContacts();
  };

  const handleToggleUsageReportsDialog = () => {
    setIsUsageReportsDialogOpen(!isUsageReportsDialogOpen);
  };

  const handleReloadUsageReports = () => {
    // add logic for fetching usage reports
  };

  return (
    <Root>
      <div className={classes.headerLinksRowOuterContainer}>
        <div className={classes.headerLinksRowInnerContainer}>
          <a
            href="https://info.blumira.com/msppricing"
            className={classes.outlinedHeaderLink}
          >
            Learn how billing works <OpenInNewIcon />
          </a>
          <a
            href="https://info.blumira.com/msppricing"
            className={classes.outlinedHeaderLink}
          >
            Compare Edition features <OpenInNewIcon />
          </a>
        </div>
        <div className={classes.headerLinksRowInnerContainer}>
          <p>Need help?</p>
          <a
            href="https://blumira.help/msp-team"
            className={classes.outlinedHeaderLink}
          >
            Book time with an MSP specialist <OpenInNewIcon />
          </a>
        </div>
      </div>
      <div className={classes.clickableCardContainer}>
        <Card
          className={classes.clickableCard}
          onClick={handleCreateNewAgreement}
        >
          <div>
            <p className={classes.clickableCardTitle}>Current agreement:</p>
            {currentAgreement ? (
              <ul className={classes.currentAgreementList}>
                <li>
                  <b>Term ends:</b> {mspBillingPlan?.termEnd}
                </li>
                <li>
                  <b>Pricing tier:</b> {mspBillingPlan?.billingPlan?.name}
                </li>
                <li>
                  <b>Minimum per month:</b>{" "}
                  {`$${mspBillingPlan?.ramp?.monthOneMin}`}
                </li>
              </ul>
            ) : (
              <p className={classes.clickableCardSecondaryText}>
                You do not currently have an active agreement. Create a new
                agreement below.
              </p>
            )}
          </div>
          {currentAgreement ? (
            <p className={classes.clickableCardCTAText}>Agreement Details</p>
          ) : (
            <p className={classes.clickableCardCTAText}>Create new agreement</p>
          )}
        </Card>
        <Card className={classes.clickableCard} onClick={handleViewInvoices}>
          <p className={classes.clickableCardTitle}>Invoices (PDF)</p>
          <p className={classes.clickableCardNumber}>O</p>
          <p className={classes.clickableCardCTAText}>View invoices</p>
        </Card>
        <Card
          className={classes.clickableCard}
          onClick={handleViewUsageReports}
        >
          <p className={classes.clickableCardTitle}>Usage reports (CSV)</p>
          <p className={classes.clickableCardNumber}>
            {props.usageReports?.length || 0}
          </p>
          <p className={classes.clickableCardCTAText}>View usage reports</p>
        </Card>
        <Card
          className={classes.clickableCard}
          onClick={handleEditPaymentMethod}
        >
          <div>
            <p className={classes.clickableCardTitle}>Payment method:</p>
            <p className={classes.clickableCardSecondaryText}>
              No payment method set up
            </p>
          </div>
          <p className={classes.clickableCardCTAText}>
            Edit payment method <OpenInNewIcon size={12} />
          </p>
        </Card>
        <Card className={classes.clickableCard} onClick={handleEditRecipients}>
          <div>
            <p className={classes.clickableCardTitle}>Billing emails go to:</p>
            {emailArray.length ? (
              emailArray.map(({ email = "" }, index) => (
                <p key={index} className={classes.clickableCardSecondaryText}>
                  {email}
                </p>
              ))
            ) : (
              <p className={classes.clickableCardSecondaryText}>
                No recipients set up
              </p>
            )}
          </div>
          <p className={classes.clickableCardCTAText}>Edit recipients</p>
        </Card>
      </div>
      <Card className={classes.accordionCard}>
        <Accordion
          expanded={isAccordionExpanded}
          onChange={handleExpandAccordion}
          className={classes.accordionContainer}
        >
          <AccordionSummary
            expandIcon={<KeyboardArrowDownIcon />}
            sx={{
              "& .MuiAccordionSummary-expandIconWrapper": {
                order: -1,
                marginRight: "15px !important",
              },
            }}
          >
            <p className={classes.accordionTitle}>Create new agreement</p>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.agreementStepContainer}>
              <p className={classes.stepTableTitleText}>
                Step 1 - Select pricing tier:
              </p>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow className={classes.tableRowRoot}>
                      <TableCell /> {/* radio, tier selection column */}
                      <TableCell>
                        <p className={classes.minimumCommitmentText}>
                          Minimum Commitment
                        </p>
                      </TableCell>
                      <TableCell /> {/* 'per user price' column */}
                      <TableCell className={classes.tablePriceCell}>
                        <p className={classes.tableColumnHeaderText}>XDR</p>
                      </TableCell>
                      <TableCell>
                        <p className={classes.tableColumnHeaderText}>SIEM+</p>
                      </TableCell>
                      <TableCell>
                        <p className={classes.tableColumnHeaderText}>
                          SIEM Pro
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className={classes.tableColumnHeaderText}>
                          Microsoft 365
                        </p>
                      </TableCell>
                      <TableCell>
                        <p className={classes.tableColumnHeaderText}>
                          Free SIEM
                        </p>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tiers.map((tier, index) => (
                      <TableRow key={index} className={classes.tableRowRoot}>
                        <TableCell className={classes.radioTableCellContainer}>
                          <Radio
                            checked={selectedTier === tier.name}
                            onChange={handleTierChange}
                            value={tier.name}
                          />
                          <Typography variant="body2">{tier.name}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {tier.commitment}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            variant="body1"
                            className={classes.tablePerUserText}
                          >
                            Per user price:
                          </Typography>
                        </TableCell>
                        {tier.prices.map((price, priceIndex) => (
                          <TableCell
                            key={priceIndex}
                            className={classes.tablePriceCell}
                          >
                            <Typography variant="body1">{price}</Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className={classes.agreementStepContainer}>
              <p className={classes.stepTitleText}>
                Step 2 - Select payment method:
              </p>
              <p className={classes.stepLargeText}>No payment method on file</p>
              <p className={classes.clickableCardCTAText}>
                Edit payment method <OpenInNewIcon size={12} />
              </p>
            </div>
            <div className={classes.agreementStepContainer}>
              <p className={classes.stepTitleText}>
                Step 3 - Set up recipient(s) for billing emails:
              </p>
              <p className={classes.clickableCardCTAText}>Add recipient</p>
            </div>
          </AccordionDetails>
        </Accordion>
      </Card>

      <MSPBillingContactsDialog
        open={isBillingContactsDialogOpen}
        toggle={handleToggleBillingContactsDialog}
        emailContacts={emailArray}
        emailString={emailString}
        reload={handleReloadBillingContacts}
      />

      <MSPUsageReportsDialog
        open={isUsageReportsDialogOpen}
        toggle={handleToggleUsageReportsDialog}
        usageReports={props.usageReports}
        reload={handleReloadUsageReports}
      />

      <StyledDialog
        open={openAgreementModal}
        onClose={() => setOpenAgreementModal(false)}
        datacy={"mspAgreementModal"}
        fullWidth
        maxWidth={"lg"}
      >
        <div className={dialogClasses.agreementTitleWrap}>
          <DialogTitle>Current Agreement Details</DialogTitle>
          <div className={dialogClasses.agreementIconWrap}>
            <IconButton
              color={"default"}
              onClick={() => setOpenAgreementModal(false)} // TODO: This needs to print/download something?
            >
              <PrintIcon />
            </IconButton>
            <IconButton
              color={"default"}
              onClick={() => setOpenAgreementModal(false)}
              sx={{ marginRight: "16px" }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <DialogContent>
          <table className={dialogClasses.dialogTable}>
            <tbody>
              <tr>
                <td className={dialogClasses.tableRowLabel}>Term Start Date</td>
                <td className={dialogClasses.tableRowText}>
                  {mspBillingPlan?.created}
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>Term End Date</td>
                <td className={dialogClasses.tableRowText}>
                  {mspBillingPlan?.termEnd}
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>Pricing Tier</td>
                <td className={dialogClasses.tableRowText}>
                  {mspBillingPlan?.billingPlan?.name}
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>Monthly Minimum</td>
                <td className={dialogClasses.tableRowText}>
                  <s
                    style={{ color: "grey" }}
                  >{`$${mspBillingPlan?.ramp?.defaultMin}`}</s>{" "}
                  {`$${mspBillingPlan?.ramp?.monthOneMin}`} per month minimum
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>
                  Per User Picing By Edition
                </td>
                <td style={{ paddingBottom: 15 }}>
                  <table className={dialogClasses.dialogTable}>
                    <tbody>
                      {mspBillingPlan?.billingPlanLicenses?.map(
                        (license, index) => (
                          <tr key={index}>
                            <td className={dialogClasses.pricingTableRowLabel}>
                              {license.itemName}
                            </td>
                            <td className={dialogClasses.pricingTableRowText}>
                              {license.itemPrice}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>
                  Terms & Conditions
                </td>
                <td
                  className={dialogClasses.tableRowText}
                  style={{ fontSize: 12 }}
                >
                  <p>
                    This Order Form (“Order Form”) is entered into as of the
                    effective date (“Effective Date”) between Blumira, Inc.
                    (“Blumira”), and the customer listed above (“Customer”).
                    This Order Form includes and incorporates (i) the above
                    Order Form, (ii) Blumira's MSP Agreement, which is set forth
                    at: www.blumira.com/managed_service_provider_agreement,
                    (iii) Blumira's Pass Through Terms and Conditions, which are
                    set forth at: blumira.help/ptt, the MSP Pricing which is
                    located:{" "}
                    <Link href="https://blumira.help/msppricing">
                      https://blumira.help/msppricing
                    </Link>
                    , and the service level agreement which is set forth at
                    www.blumira.com/sla, all of which are incorporated by
                    reference. There shall be no force or effect to any
                    different terms of any Customer purchasing documents, unless
                    signed by both parties, after the date hereof. Unless
                    otherwise stated at{" "}
                    <Link href="https://blumira.help/msppricing">
                      https://blumira.help/msppricing
                    </Link>
                    , when new products or editions are released and made
                    available at{" "}
                    <Link href="https://blumira.help/msppricing">
                      https://blumira.help/msppricing
                    </Link>
                    , Customer may access them as a part of this agreement at
                    their existing MSP Plan Tier as long as Customer is in good
                    standing with their contract.
                  </p>

                  <p>
                    Following the Initial Term as defined by the Subscription
                    start and end dates above, this Order Form term shall
                    automatically renew for additional successive periods of
                    equal duration to the Initial Term (each, a “Renewal Term”)
                    unless either party notifies the other party of such party's
                    intention not to renew no less than thirty (30) days prior
                    to the expiration of the then-current term. If the Customer
                    does not have an Order Form in place with a current term but
                    still has sub-accounts on paid editions in their MSP Portal,
                    those will be billed at the then-current prices at{" "}
                    <Link href="blumira.com/pricing">blumira.com/pricing</Link>.
                  </p>
                </td>
              </tr>
              <tr>
                <td className={dialogClasses.tableRowLabel}>Auto-renewal</td>
                <td className={dialogClasses.tableRowText}>
                  <FormControlLabel
                    control={
                      <Switch
                        defaultChecked
                        checked={mspBillingPlan?.autoRenew}
                      />
                    }
                    label="Enabled (renews automatically June 1, 2025)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
      </StyledDialog>
    </Root>
  );
};

const mapStateToProps = (state) => ({
  license: state.license,
  orgId: state.location.payload.orgId,
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MSPBillingPageView);
